module.exports = "https://cdn.littlereply.com/tt/resource/image_more_item_invite@3x.548497756897df1e6bf42e75b86bb2bf.png";